import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import React from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { styles } from "./UseCasesView.styles";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { AnchorLink } from "../../components/Links/AnchorLink";

export interface IUseCaseModel {
    id: number;
    name: string;
    description?: string;
    link: string;
    categories?: number[];
}
interface IUseCaseProps extends WithStyles<typeof styles> {
    useCase: IUseCaseModel;
}

const UseCasePure: React.FunctionComponent<IUseCaseProps> = ({ classes, useCase }) => {
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                <Typography variant="h4">{useCase?.name}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography component={"div"} variant="body1">
                            {useCase?.description}
                        </Typography>
                    </Grid>
                    <Grid container spacing={2} className={classes.root}>
                        <Grid key={1} item xs={5}>
                            <OpenInNewIcon />
                            <AnchorLink variant="subtitle2" to={useCase?.link} newWindow>
                                Open external link
                            </AnchorLink>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export const UseCase = withStyles(styles)(UseCasePure);
